const checkPermission = (permissions, permissionSlug) => {
  return Number(permissions[permissionSlug]) === 1;
};

export default checkPermission;
